module.exports = __webpack_public_path__ + "static/media/Ordkjedetest_eksempler-correctAnswer.2ecd46c7.m4a";